// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import BackgroundJpg from "./assets/background.jpg";
import Map_backgroundPng from "./assets/map_background.png";
import Tile_backgroundSvg from "./assets/tile_background.svg";
import Void_backgroundWebp from "./assets/void_background.webp";
import * as Wrap$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Wrap.res.mjs";
import * as PageTypes$LiteracyplanetClientSxEntry from "../PageTypes.res.mjs";
import * as UserContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/UserContext.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as MarginPanel$LiteracyplanetClientSxEntry from "./MarginPanel.res.mjs";
import * as MobileUtils$LiteracyplanetClientSxEntry from "../MobileUtils.res.mjs";
import * as InitialsMenu$LiteracyplanetClientSxEntry from "./InitialsMenu.res.mjs";
import * as SecondaryNavBar$LiteracyplanetClientSxEntry from "./SecondaryNavBar.res.mjs";
import * as StoryverseNavBar$LiteracyplanetClientSxEntry from "./StoryverseNavBar.res.mjs";
import * as BackgroundComponent$LiteracyplanetClientSxEntry from "./BackgroundComponent.res.mjs";

var backgroundSrc = BackgroundJpg;

var intrepizineBackgroundSrc = Tile_backgroundSvg;

var voidBackgroundSrc = Void_backgroundWebp;

var mapBackgroundSrc = Map_backgroundPng;

function use(redirect, whatExperience, isPageBlacklisted) {
  var libraryPage = {
    TAG: "StudentLibrary",
    _0: undefined,
    _1: undefined
  };
  FlagsContext$LiteracyplanetClientFlags.use();
  var onClickCollections = function (param) {
    return Curry._1(redirect, "StudentCollections");
  };
  var onClickShop = function (param) {
    return Curry._1(redirect, "AvatarShop");
  };
  var onClickAcademy = function (param) {
    return Curry._1(redirect, "AcademyIndex");
  };
  var onClickWordFlyers = function (param) {
    return Curry._1(redirect, {
                TAG: "WordFlyersIndex",
                _0: undefined,
                _1: undefined
              });
  };
  var onClickArcade = function (param) {
    return Curry._1(redirect, "Arcade");
  };
  var onClickLibrary = function (param) {
    return Curry._1(redirect, libraryPage);
  };
  var onClickIntrepizine = function (param) {
    return Curry._1(redirect, {
                TAG: "Intrepizine",
                _0: undefined
              });
  };
  var onClickMyWords = function (param) {
    return Curry._1(redirect, "MyWordsLists");
  };
  var onClickBog = function (param) {
    return Curry._1(redirect, "Bog");
  };
  var onClickReports = function (param) {
    return Curry._1(redirect, "OverviewReport");
  };
  var lockCollections = Curry._1(isPageBlacklisted, "StudentCollections");
  var lockShop = Curry._1(isPageBlacklisted, "AvatarShop");
  var lockArcade = Curry._1(isPageBlacklisted, "Arcade");
  var lockLibrary = Curry._1(isPageBlacklisted, libraryPage);
  var lockMyWords = Curry._1(isPageBlacklisted, "MyWordsLists");
  if (whatExperience === "Secondary") {
    var onClickMissions = function (param) {
      return Curry._1(redirect, {
                  TAG: "SecondaryMissions",
                  _0: undefined
                });
    };
    return [
            onClickMissions,
            onClickAcademy,
            onClickWordFlyers,
            onClickCollections,
            onClickShop,
            onClickArcade,
            onClickLibrary,
            onClickIntrepizine,
            onClickMyWords,
            onClickBog,
            onClickReports,
            lockCollections,
            lockShop,
            lockArcade,
            lockLibrary,
            lockMyWords
          ];
  }
  var onClickMissions$1 = function (param) {
    return Curry._1(redirect, "JourneyMissions");
  };
  return [
          onClickMissions$1,
          onClickAcademy,
          onClickWordFlyers,
          onClickCollections,
          onClickShop,
          onClickArcade,
          onClickLibrary,
          onClickIntrepizine,
          onClickMyWords,
          onClickBog,
          onClickReports,
          lockCollections,
          lockShop,
          lockArcade,
          lockLibrary,
          lockMyWords
        ];
}

var MakeRoutes = {
  use: use
};

function getInitial(word) {
  var sanitised = word.trim().toUpperCase();
  if (sanitised.length > 0) {
    return sanitised.substring(0, 1) + ".";
  } else {
    return "";
  }
}

function StudentExperienceWrap(props) {
  var children = props.children;
  var page = props.page;
  var layout = props.layout;
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userName = user.name;
  var userInitials = getInitial(user.givenName) + getInitial(user.familyName);
  var whatExperience = Wrap$LiteracyplanetClientFlags.useStudentExperience();
  var match = use(props.redirect, whatExperience, props.isPageBlacklisted);
  var lockArcade = match[13];
  var lockShop = match[12];
  var onClickMyWords = match[8];
  var onClickIntrepizine = match[7];
  var onClickLibrary = match[6];
  var onClickArcade = match[5];
  var onClickShop = match[4];
  var onClickCollections = match[3];
  var onClickWordFlyers = match[2];
  var onClickAcademy = match[1];
  var onClickMissions = match[0];
  var user$1 = UserContext$LiteracyplanetClientFlags.use();
  var showLibraryLink = Curry._1(hasFlag, "StudentCanUseLibrary");
  var showArcade = Curry._1(hasFlag, "StudentHasArcade");
  var supportMode = user$1.supportMode && Curry._1(hasFlag, {
        NAME: "Classic",
        VAL: "login-as-student"
      });
  var showTeacherModeWidget = (Curry._1(hasFlag, "StudentIsStudentMode") || supportMode) && !process.env.MOBILE;
  var studentModeUrl = supportMode ? PageTypes$LiteracyplanetClientSxEntry.classicUrl("/resume_teacher") : PageTypes$LiteracyplanetClientSxEntry.classicUrl("/student_mode");
  var onClickTeacherMode = function (param) {
    MobileUtils$LiteracyplanetClientSxEntry.signOutTo(studentModeUrl);
  };
  var onClickLogout = function (param) {
    MobileUtils$LiteracyplanetClientSxEntry.signOut();
  };
  var whatMenu = Wrap$LiteracyplanetClientFlags.useMenu();
  var whatNavBar = Wrap$LiteracyplanetClientFlags.useNavBar();
  var menu;
  menu = whatMenu === "Initials" ? React.createElement(InitialsMenu$LiteracyplanetClientSxEntry.make, {
          collectionNotificationCount: 0,
          userName: userName,
          userInitials: userInitials,
          onClickLogout: onClickLogout,
          refreshApp: props.refreshApp
        }) : null;
  var isAcademy;
  if (typeof page !== "object") {
    isAcademy = page === "AcademyIndex" ? true : false;
  } else {
    switch (page.TAG) {
      case "AcademyMenu" :
      case "AcademyMenuActivities" :
      case "AcademyActivity" :
          isAcademy = true;
          break;
      default:
        isAcademy = false;
    }
  }
  var isMissions;
  isMissions = typeof page !== "object" ? (
      page === "JourneyMissions" ? true : false
    ) : (
      page.TAG === "SecondaryMissions" ? true : false
    );
  var isCollections;
  isCollections = typeof page !== "object" && page === "StudentCollections" ? true : false;
  var isLibrary;
  if (typeof page !== "object") {
    isLibrary = false;
  } else {
    switch (page.TAG) {
      case "StudentLibrary" :
      case "Intrepizine" :
          isLibrary = true;
          break;
      default:
        isLibrary = false;
    }
  }
  var isArcade;
  isArcade = typeof page !== "object" && page === "Arcade" ? true : false;
  var isMyWords;
  isMyWords = typeof page !== "object" && page === "MyWordsLists" ? true : false;
  var navBar;
  switch (whatNavBar) {
    case "Secondary" :
        navBar = React.createElement(SecondaryNavBar$LiteracyplanetClientSxEntry.make, {
              collectionNotificationCount: 0,
              highlightAcademy: isAcademy,
              onClickAcademy: onClickAcademy,
              onClickWordFlyers: onClickWordFlyers,
              highlightMissions: isMissions,
              onClickMissions: onClickMissions,
              highlightCollections: isCollections,
              lockCollections: match[11],
              onClickCollections: onClickCollections,
              highlightArcade: isArcade,
              showArcade: showArcade,
              lockArcade: lockArcade,
              onClickArcade: onClickArcade,
              lockShop: lockShop,
              onClickShop: onClickShop,
              highlightLibrary: isLibrary,
              showLibraryLink: showLibraryLink,
              lockLibrary: match[14],
              onClickLibrary: onClickLibrary,
              onClickIntrepizine: onClickIntrepizine,
              highlightMyWords: isMyWords,
              lockMyWords: match[15],
              onClickMyWords: onClickMyWords,
              onClickTeacherMode: onClickTeacherMode,
              showTeacherModeWidget: showTeacherModeWidget,
              menu: menu
            });
        break;
    case "Barless" :
        navBar = menu;
        break;
    case "Storyverse" :
        navBar = React.createElement(StoryverseNavBar$LiteracyplanetClientSxEntry.make, {
              userName: userName,
              location: "Shabby Hut",
              onClickAcademy: onClickAcademy,
              onClickWordFlyers: onClickWordFlyers,
              onClickMissions: onClickMissions,
              onClickIntrepizine: onClickIntrepizine,
              onClickMyWords: onClickMyWords,
              onClickLibrary: onClickLibrary,
              onClickBog: match[9],
              onClickCollections: onClickCollections,
              lockArcade: lockArcade,
              onClickArcade: onClickArcade,
              lockShop: lockShop,
              onClickShop: onClickShop,
              showLibraryLink: showLibraryLink,
              onClickReports: match[10],
              onClickLogout: onClickLogout,
              showTeacherModeWidget: showTeacherModeWidget,
              onClickTeacherMode: onClickTeacherMode,
              menu: menu
            });
        break;
    
  }
  var bg;
  switch (props.background) {
    case "MainBackground" :
        bg = {
          TAG: "Src",
          _0: backgroundSrc
        };
        break;
    case "IntrepizineBackground" :
        bg = {
          TAG: "TiledSrc",
          _0: intrepizineBackgroundSrc
        };
        break;
    case "VoidBackground" :
        bg = {
          TAG: "Src",
          _0: voidBackgroundSrc
        };
        break;
    case "NoBackground" :
        bg = {
          TAG: "Color",
          _0: "FFF"
        };
        break;
    case "MapBackground" :
        bg = {
          TAG: "Src",
          _0: mapBackgroundSrc
        };
        break;
    
  }
  if (whatExperience === "Secondary") {
    switch (layout) {
      case "AuthWithMenu" :
          return React.createElement(React.Fragment, {}, navBar, React.createElement(BackgroundComponent$LiteracyplanetClientSxEntry.make, {
                          background: bg,
                          dark: true,
                          children: children
                        }));
      case "AuthWithTitleBar" :
          return React.createElement(React.Fragment, {}, navBar, React.createElement(BackgroundComponent$LiteracyplanetClientSxEntry.make, {
                          background: bg,
                          dark: false,
                          children: React.createElement(MarginPanel$LiteracyplanetClientSxEntry.make, {
                                children: children,
                                topMargin: 100
                              })
                        }));
      case "AuthWithTitleBarAndHeader" :
          return React.createElement(React.Fragment, {}, navBar, React.createElement(BackgroundComponent$LiteracyplanetClientSxEntry.make, {
                          background: bg,
                          dark: false,
                          children: React.createElement(MarginPanel$LiteracyplanetClientSxEntry.make, {
                                children: children,
                                topMargin: 150
                              })
                        }));
      case "DarkBackground" :
          return React.createElement(BackgroundComponent$LiteracyplanetClientSxEntry.make, {
                      background: bg,
                      dark: true,
                      children: children
                    });
      case "PlainBackground" :
      case "AuthNoMenu" :
          return React.createElement(BackgroundComponent$LiteracyplanetClientSxEntry.make, {
                      background: bg,
                      dark: false,
                      children: children
                    });
      
    }
  } else {
    switch (layout) {
      case "AuthWithMenu" :
          return React.createElement(BackgroundComponent$LiteracyplanetClientSxEntry.make, {
                      background: bg,
                      dark: false,
                      children: null
                    }, navBar, children);
      case "AuthWithTitleBar" :
          return React.createElement(React.Fragment, {}, navBar, React.createElement(BackgroundComponent$LiteracyplanetClientSxEntry.make, {
                          background: bg,
                          dark: false,
                          children: children
                        }));
      case "AuthWithTitleBarAndHeader" :
          return React.createElement(React.Fragment, {}, navBar, React.createElement(BackgroundComponent$LiteracyplanetClientSxEntry.make, {
                          background: bg,
                          dark: false,
                          children: React.createElement(MarginPanel$LiteracyplanetClientSxEntry.make, {
                                children: children,
                                topMargin: 150
                              })
                        }));
      case "DarkBackground" :
          return React.createElement(BackgroundComponent$LiteracyplanetClientSxEntry.make, {
                      background: bg,
                      dark: true,
                      children: children
                    });
      case "PlainBackground" :
      case "AuthNoMenu" :
          return React.createElement(BackgroundComponent$LiteracyplanetClientSxEntry.make, {
                      background: bg,
                      dark: false,
                      children: children
                    });
      
    }
  }
}

function useStudentRedirectToMissions(redirect, isPageBlacklisted) {
  var whatExperience = Wrap$LiteracyplanetClientFlags.useStudentExperience();
  return use(redirect, whatExperience, isPageBlacklisted)[0];
}

var make = StudentExperienceWrap;

export {
  backgroundSrc ,
  intrepizineBackgroundSrc ,
  voidBackgroundSrc ,
  mapBackgroundSrc ,
  MakeRoutes ,
  getInitial ,
  make ,
  useStudentRedirectToMissions ,
}
/* backgroundSrc Not a pure module */
